import { useMutation, UseMutationResult, useQuery, UseQueryResult, useQueryClient } from "react-query"
import CarrotClient from "../../../lib/carrot-api"
import CarrotCardClient from "../../../lib/carrot-card"
import Settings from "../../../utils/CarrotConfig"
import { RetryConfig } from "utils/ErrorHandling"
import { RelatedCompany } from "types/Company"
import { CarrotCardLaunchRequest, CarrotCardLaunchResponse } from "types/CarrotCardAccount"
import ResponseError from "utils/ResponseError"

const carrotClient = new CarrotClient(Settings.CARROT_BACKEND_URL)
const carrotCardClient = new CarrotCardClient(Settings.CARROT_BACKEND_URL)

const RELATED_COMPANIES = "related-companies"
const LAUNCH_CARROT_CARD = "launch-carrot-card"

export function useRelatedCompanies(companyId: number): UseQueryResult<RelatedCompany[], ResponseError> {
  return useQuery<RelatedCompany[], ResponseError>(
    [RELATED_COMPANIES, companyId],
    () => carrotClient.getRelatedCompanies(companyId),
    {
      ...RetryConfig,
      enabled: !!companyId
    }
  )
}

export function useLaunchCarrotCard(
  carrotCardAccountId: string
): UseMutationResult<CarrotCardLaunchResponse, ResponseError, CarrotCardLaunchRequest> {
  const queryClient = useQueryClient()
  return useMutation<CarrotCardLaunchResponse, ResponseError, CarrotCardLaunchRequest>(
    (launchRequest: CarrotCardLaunchRequest) => carrotCardClient.launchCarrotCard(carrotCardAccountId, launchRequest),
    {
      ...RetryConfig,
      onSuccess: () => {
        queryClient.invalidateQueries([LAUNCH_CARROT_CARD, carrotCardAccountId])
      }
    }
  )
}
